export default "__VITE_ASSET__854ff381__"